import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import { HashRouter, Route, Routes } from "react-router-dom";
import { App } from "./App";
import Login from "./pages/login";
import LoginSms from "./pages/login/indexSms";
import "./index.css";
import { ApiClient, SiteInfo } from "./api/ApiClient";
import User from "./pages/user";
import NotFound from "./pages/notfound";
import Role from "./pages/role";
import RoleGroup from "./pages/roleGroup";
import Config from "./pages/config";
import { ClientConfigPage } from "./pages/clientConfig";
import ClientLog from "./pages/clientLog";
import Product from "./pages/product";
import Leads from "./pages/leads";
import PoolLeads from "./pages/leads/poolLead";
import RejectLeads from "./pages/leads/rejectLead";
import WasteLeads from "./pages/leads/wasteLead";
import SaleLeads from "./pages/leads/saleLead";
import SaleNewLeads from "./pages/leads/saleNewLead";
import SaleFavLeads from "./pages/leads/saleFavLead";
import TeamLeads from "./pages/leads/teamLead";
import NewLeadDetail from "./pages/leads/newLeadDetail";
import LoanLeadDetail from "./pages/loan/loanLeadDetail";
import LeadDetailNewOut from "./pages/leads/leadDetailNewOut";


import AllLoan from "./pages/loan/allLoan";
import NotAssignLoan from "./pages/loan/notAssignLoan";
import MyLoan from "./pages/loan/myLoan";
import TeamLoan from "./pages/loan/teamLoan";
import NewLoan from "./pages/loan/newLoan";
import PaidLoan from "./pages/loan/paidLoan";
import PayoutLoan from "./pages/loan/payoutLoan";
import Dict from "./pages/dict";
import TeamPage from "./pages/team";
import TrafficApp from "./pages/trafficApp";
import PoolSetting from "./pages/poolSetting";
import FindLead from "./pages/leads/findLead";
import { SiteInfoContext } from "./pages/context/SiteInfoContext";
import TeamMember from "./pages/teamMember";
import OrgUserStarStat from "./pages/stat/orgUserStarStat";
import OrgUserStarStatPersonal from "./pages/stat/orgUserStarStatPersonal";
import OrgUserNewLeadStarStat from "./pages/stat/orgUserNewLeadStarStat";
import SourceStarStat from "./pages/stat/sourceStarStat";
import LeadVisitSignLog from "./pages/leadVisitSignLog";
import VisitSign from "./pages/leadVisitSignLog/visitSign";
import TestPage from "./pages/testPage";
import AgainAssignStarStat from "./pages/stat/againAssignStarStat";
import AssignVisitStat from "./pages/stat/assignVisitStat";
import AssignVisitStatPersonal from "./pages/stat/assignVisitStatPersonal";
import LeadMd5Mobile from "./pages/config/leadMd5Mobile";
import AssignVisitStatDate from "./pages/stat/assignVisitStatDate";
import CustomerTouchStat from "./pages/stat/customerTouchStat";
import CallStat from "./pages/stat/callStat";
import TeamManager from "./pages/teamManager";
import RedisManager from "./pages/redisManager";
import ScheduledTask from "./pages/scheduledTask";
import BankTrustEnterprise from "./pages/bankTrustEnterprise";
import AiChat from "./pages/aiChat";
import ApiConfig from "./pages/apiConfig";
import DataVisual from "./pages/dataVisual";
import IndexMortgageLead from "./pages/mortgageLoan/indexMortgageLead";
import IndexMortgageLeadSettle from "./pages/mortgageLoan/indexMortgageLeadSettle";
import IndexRepaymentPlan from "./pages/mortgageLoan/indexRepaymentPlan";
import IndexPaidPlan from "./pages/mortgageLoan/indexOutMoneyPlan";
import IndexPaidPlanSettle from "./pages/mortgageLoan/indexPaidPlanSettle";
import UserApiService from "./pages/testPage/UserApiService";
import NewWindowIndexMortgageLoan from "./pages/mortgageLoan/newWindowIndexMortgageLoan";
import IndexMortgageLoanQuery from "./pages/mortgageLoan/indexMortgageLoanQuery";
import IndexRepaymentPlanQuery from "./pages/mortgageLoan/indexRepaymentPlanQuery";
import LoginLog from "./pages/loginLog";
import IndexPaidPlanByDate from "./pages/mortgageLoan/indexPaidPlanByDate";
import IndexLeadImportLog from "./pages/leadImportLog";
import IndexLeadImportHit from "./pages/leadImportLog/indexHit";
import LeadCheckEmptyMobileLog from "./pages/leadCheckEmptyMobileLog";
import IndexStatOutMoneyPlan from "./pages/mortgageLoan/indexStatOutMoneyPlan";
import LeadWarehouse from "./pages/leadWarehouse";
import LeadFeedbackLog from "./pages/leadFeedbackLog";
import SourceStarStatDkhit from "./pages/stat/sourceStarStatDkhit";
import CancellationLead from "./pages/leads/cancellationLead";
import PlanRepaymentReportAgentAndCustomer from "./pages/mortgageLoanReport/planRepaymentReportAgentAndCustomer";
import NewWindowReleaseLeadPage from "./pages/mortgageLoan/newWindowReleaseLead";
import IndexStatOutMoneyPlanLead from "./pages/mortgageLoan/indexStatOutMoneyPlanLead";
import IndexStatOutMoneyPlanLeadAndCustomer from "./pages/mortgageLoan/indexStatOutMoneyPlanLeadAndCustomer";
import StatOutMoneyByMonth from "./pages/mortgageLoan/statOutMoneyByMonth";
import LoanAnomalyMonitor from "./pages/mortgageLoan/loanAnomalyMonitor";
import UserOperationLog from "./pages/userOperationLog";
import IndexLeadExt from "./pages/mortgageLoan/indexLeadExt";
import IndexReconciliation from "./pages/mortgageLoan/indexReconciliation";
import IndexReconciliationByLead from "./pages/mortgageLoan/indexReconciliationByLead";
import IndexReconciliationByLeadAndCustomer from "./pages/mortgageLoan/indexStatOutMoneyPlanLeadAndCustomer";
import PoolScoring from "./pages/leads/poolScoring";
import LlmConfig from "./pages/leads/llmConfig";
import IntentRuleConfig from "./pages/leads/intentRuleConfig";
import ScoringKeywordConfig from "./pages/leads/scoringKeywordConfig";
import LeadExactScoring from "./pages/leads/leadExactScoring";
import LeadProfileOut from "./pages/leads/leadProfileOut";
import CallRecord from "./pages/leads/callRecord";
import AiCustomerAnalysis from "./pages/leads/aiCustomerAnalysis";
import LogViewer from "./pages/logViewer";
import OpsAssistant from "./pages/opsAssistant";
import OpsLogin from "./pages/opsLogin";
import UserProfile from "./pages/userProfile";
import TeamPortrait from "./pages/teamPortrait";
import Manual from "./pages/manual";
import Contract from "./pages/contract";
import AiWeeklyReport from "./pages/aiWeeklyReport";
import AiCoachChat from "./pages/aiCoachChat";
import HomeDashboard from "./pages/homeDashboard";
import LeadAssign from "./pages/leads/leadAssign";
import Contacts from "./pages/contacts";


let apiClient = ApiClient.getDefault();
let Main = () => {
  const [siteInfo, setSiteInfo] = useState(undefined as undefined | SiteInfo);
  useEffect(() => {
    apiClient.getSiteInfo().then((r) => {
      setSiteInfo(r.data);
    });
  }, []);

  const router = (
    <HashRouter>
      <Routes>
        <Route path="/" element={<App />}>
          <Route path="users" element={<User />} />
          <Route path="roles" element={<Role />} />
          <Route path="roleGroup" element={<RoleGroup />} />
          <Route path="configs" element={<Config />} />
          <Route path="clientLogs" element={<ClientLog />} />
          <Route path="loginLogs" element={<LoginLog />} />
          <Route path="poolSettings" element={<PoolSetting />} />
          <Route path="products" element={<Product />} />
          <Route path="trafficApps" element={<TrafficApp />} />
          <Route path="dicts" element={<Dict />} />

          <Route path="teams" element={<TeamPage />} />
          <Route path="teamMembers" element={<TeamMember />} />
          <Route path="leads" element={<Leads />} />
          <Route path="findLeads" element={<FindLead />} />
          <Route path="saleLeads" element={<SaleLeads />} />
          <Route path="saleNewLeads" element={<SaleNewLeads />} />
          <Route path="saleFavLeads" element={<SaleFavLeads />} />
          <Route path="teamLeads" element={<TeamLeads />} />
          <Route path="pool" element={<PoolLeads />} />
          <Route path="reject" element={<RejectLeads />} />
          <Route path="waste" element={<WasteLeads />} />
          <Route path="loans" element={<AllLoan />} />
          <Route path="notAssignLoans" element={<NotAssignLoan />} />
          <Route path="myLoan" element={<MyLoan />} />
          <Route path="teamLoan" element={<TeamLoan />} />
          <Route path="newLoans" element={<NewLoan />} />
          <Route path="passedLoans" element={<PayoutLoan />} />
          <Route path="paidLoans" element={<PaidLoan />} />
          <Route path="leadVisitSignLog" element={<LeadVisitSignLog />} />
          <Route path="orgUserStarStat" element={<OrgUserStarStat />} />
          <Route path="leadExt" element={<IndexLeadExt />} />
          <Route path="reconciliation" element={<IndexReconciliation />} />
          <Route path="reconciliationByLead" element={<IndexReconciliationByLead />} />
          <Route path="reconciliationAll" element={<IndexReconciliationByLeadAndCustomer />} />
          <Route path="poolScoring" element={<PoolScoring />} />
          <Route path="intentRuleConfig" element={<IntentRuleConfig />} />
          <Route path="scoringKeywordConfig" element={<ScoringKeywordConfig />} />
          <Route path="leadExactScoring" element={<LeadExactScoring />} />
          <Route path="callRecord" element={<CallRecord />} />
          <Route path="leadAssign" element={<LeadAssign />} />
          <Route path="contacts" element={<Contacts />} />

          <Route
            path="orgUserStarStatPersonal"
            element={<OrgUserStarStatPersonal />}
          />
          <Route path="orgUserNewLeadStarStat" element={<OrgUserNewLeadStarStat />} />
          <Route path="sourceStarStat" element={<SourceStarStat />} />
          <Route path="againAssignStarStat" element={<AgainAssignStarStat />} />
          <Route path="assignVisitStat" element={<AssignVisitStat />} />
          <Route
            path="assignVisitStatPersonal"
            element={<AssignVisitStatPersonal />}
          />
          <Route
            path="assignVisitStatDate"
            element={<AssignVisitStatDate />}
          />
          <Route
            path="customerTouchStat"
            element={<CustomerTouchStat />}
          />
          <Route
            path="callStat"
            element={<CallStat />}
          />
          <Route path="leadMd5Mobile" element={<LeadMd5Mobile />} />

          <Route
            path="smsConfig"
            element={<ClientConfigPage title="短信通道配置" clientType="SMS" />}
          />
          <Route
            path="storageConfig"
            element={
              <ClientConfigPage title="文件存储配置" clientType="STORAGE" />
            }
          />
          <Route path="teamManager" element={<TeamManager />} />
         
          <Route path="bankTrustEnterprise" element={<BankTrustEnterprise />} />
          <Route path="aichat" element={<AiChat />} />
          <Route path="/mortgageLead" element={<IndexMortgageLead />} />
          <Route path="/mortgageLeadSettle" element={<IndexMortgageLeadSettle />} />
          <Route path="/repaymentPlan" element={<IndexRepaymentPlan />} />
          <Route path="/paidPlan" element={<IndexPaidPlan/>} />
          <Route path="/statOutMoneyPlan" element={<IndexStatOutMoneyPlan/>} />
          <Route path="/paidPlanSettle" element={<IndexPaidPlanSettle/>} />
          <Route path="/mortgageLoanQuery" element={<IndexMortgageLoanQuery />} />
          <Route path="/repaymentPlanQuery" element={<IndexRepaymentPlanQuery />} />
          <Route path="/paidPlanByDate" element={<IndexPaidPlanByDate/>} />
          <Route path="/leadImportLog" element={<IndexLeadImportLog/>} />
          <Route path="/leadImportHit" element={<IndexLeadImportHit/>} />
          <Route path="/leadCheckEmptyMobile" element={<LeadCheckEmptyMobileLog/>} />
          <Route path="/leadWarehouse" element={<LeadWarehouse/>} />
          <Route path="/leadFeedbackLog" element={<LeadFeedbackLog/>} />
          <Route path="/sourceStarStatDkhit" element={<SourceStarStatDkhit/>} />
          <Route path="/cancellation" element={<CancellationLead/>} />
          <Route path="/monthPlanRepaymentReport" element={<PlanRepaymentReportAgentAndCustomer/>} />
          <Route path="/statOutMoneyPlanAll" element={<IndexStatOutMoneyPlanLeadAndCustomer/>} />
          <Route path="/statOutMoneyPlanLead" element={<IndexStatOutMoneyPlanLead/>} />
          <Route path="/statOutMoneyAnalysis" element={<StatOutMoneyByMonth/>} />
          <Route path="/loanAnomalyMonitor" element={<LoanAnomalyMonitor/>} />
          <Route path="/userOperationLog" element={<UserOperationLog/>} />
          <Route path="/aiCustomerAnalysis" element={<AiCustomerAnalysis/>} />
          <Route path="/contracts" element={<Contract/>} />
          <Route path="aiWeeklyReport" element={<AiWeeklyReport />} /> 
          <Route path="aiCoachChat" element={<AiCoachChat />} />
          <Route path="homeDashboard" element={<HomeDashboard />} />
           

          
        </Route>
        
        <Route path="/newlead" element={<NewLeadDetail />} />
        <Route path="/leadDetailNew" element={<LeadDetailNewOut />} />
        <Route path="/loanlead" element={<LoanLeadDetail />} />
        <Route path="/login" element={<Login />} />
        <Route path="/loginSms" element={<LoginSms />} />
        <Route path="/visitSign" element={<VisitSign />} />
        <Route path="/test" element={<TestPage />} />
        <Route path="/testTable" element={<UserApiService />} />
        <Route path="/apiConfig" element={<ApiConfig />} />
        <Route path="/dataVisual" element={<DataVisual />} />
        <Route path="/newLeadLoan" element={<NewWindowIndexMortgageLoan />} />
        <Route path="/releaseLead" element={<NewWindowReleaseLeadPage />} />
         <Route path="/leadProfile" element={<LeadProfileOut />} />
         <Route path="/opsLogin" element={<OpsLogin />} />
        <Route path="/opsAssistant" element={<OpsAssistant />} />
        <Route path="/logViewer" element={<LogViewer/>} />
        <Route path="redisManager" element={<RedisManager />} />
        <Route path="scheduledTask" element={<ScheduledTask />} />
        <Route path="userProfile" element={<UserProfile />} />
        <Route path="teamPortrait" element={<TeamPortrait />} />
        <Route path="llmConfig" element={<LlmConfig />} />  
        <Route path="manualCenter" element={<Manual />} />  

        <Route path="*" element={<NotFound />} />
      </Routes>
    </HashRouter>
  );
  return (
    <SiteInfoContext.Provider value={siteInfo}>
      {router}
    </SiteInfoContext.Provider>
  );
};
ReactDOM.createRoot(document.getElementById("root")!).render(<Main />);
